import React from 'react';
import LazyImage from '../../components/LazyImage';

const CTASection: React.FC = () => {
  return (
    <section className="relative min-h-[650px] md:min-h-0 md:h-[533px] flex items-center overflow-hidden py-8 md:py-0">
      {/* Background Image */}
      <LazyImage 
        src="/images/mofu.webp" 
        alt="Financial charts background" 
        className="absolute inset-0 w-full h-full object-cover scale-x-[1.3] object-left"
        sizes="100vw"
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#1A2A44] bg-opacity-90 z-10"></div>

      {/* Content */}
      <div className="relative z-10 mx-auto px-4 md:px-10 lg:px-32 w-full max-w-4xl py-8 md:py-0">
        <div className="text-center space-y-4">
          {/* First Paragraph */}
          <p className="text-[#FFFFFF] text-[18px] font-[500] leading-[24px] tracking-[0.36px] text-center">
          These ten tips form the core of how I approach junior mining — and what we discuss daily inside The Wealthy Miner community.
          </p>

          {/* Second Paragraph */}
          <p className="text-[#FFFFFF] text-[18px] font-[500] leading-[24px] tracking-[0.36px] text-center">
          If you're ready for real-time application of these principles — including current watchlists, live Q&A, and portfolio workshops — join us today.
          </p>

          {/* Third Paragraph */}
          <p className="text-[#FFFFFF] text-[18px] font-[500] leading-[24px] tracking-[0.36px] text-center">
          Get instant access to exclusive insights, monthly reports, and direct conversation with like-minded serious investors.
          </p>

          {/* CTA Button */}
          <div className="pt-2">
            <a
              href="https://the-wealthy-miner.mn.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#0B6054] text-white px-8 md:px-12 lg:px-16 py-3 md:py-4 rounded-[10px] font-[700] text-[16px] md:text-[18px] lg:text-[20px] hover:bg-[#0d7a6b] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#0B6054] focus:ring-opacity-50"
            >
              Join The Wealthy Miner Now
            </a>
          </div>

          {/* Disclaimer */}
          <div className="pt-4 mt-4 ">
            <p className="text-[#84B1E2] text-[14px] md:text-[12px] font-[400] leading-[16px] md:leading-[18px] lg:text-justify text-center">
              <strong className="font-[700]">Disclaimer:</strong> The above content is for informational use only and should not be used as an alternative to the financial and legal advice of a qualified professional in business planning and investment. We do not represent that forecasts in this report will lead to a specific outcome or result, and are not liable in the event of any business action taken in whole or in part as a result of the information above.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
